import { render } from "./AppraisalFormManagement.vue?vue&type=template&id=a82cf3de&scoped=true"
import script from "./AppraisalFormManagement.vue?vue&type=script&lang=js"
export * from "./AppraisalFormManagement.vue?vue&type=script&lang=js"

import "./AppraisalFormManagement.vue?vue&type=style&index=0&id=a82cf3de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82cf3de"]])

export default __exports__